import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Anchor } from './anchor';

@Component({
  selector: 'anchor',
  templateUrl: './anchor.component.html',
  standalone: true,
})
export class AnchorComponent {
  @Input() data: Anchor;
  private readonly SCROLL_DELAY_MS = 300; // Wait for DOM to fully render before scrolling

  constructor(private route: ActivatedRoute) {}

  get name(): string {
    return this.data?.anchorName;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const fragment = this.route.snapshot.fragment;
      if (fragment) {
        const element = document.getElementById(fragment);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }, this.SCROLL_DELAY_MS);
  }
}
